
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"54","height":"54"}},[_c('path',{attrs:{"d":"M53.112 0H.972v53.638h52.14V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)","fill":"#fff"}},[_c('path',{attrs:{"d":"M28.12 34.178a13.09 13.09 0 008.016-3.803 13.11 13.11 0 003.876-9.332 1.31 1.31 0 00-1.307-1.305 1.31 1.31 0 00-1.308 1.305c0 2.825-1.102 5.49-3.11 7.486a10.547 10.547 0 01-7.502 3.104h-.159c-2.83 0-5.502-1.1-7.501-3.104-2-1.995-3.11-4.661-3.11-7.486a1.31 1.31 0 00-1.309-1.305 1.31 1.31 0 00-1.308 1.305c0 3.524 1.374 6.843 3.877 9.332a13.09 13.09 0 008.015 3.803l.103.01v9.927h-6.446a1.31 1.31 0 00-1.307 1.305 1.31 1.31 0 001.307 1.305h15.498a1.31 1.31 0 001.308-1.305 1.31 1.31 0 00-1.308-1.305h-6.436v-9.928l.112-.01z"}}),_c('path',{attrs:{"d":"M26.624 28.584h.159c4.166 0 7.557-3.383 7.557-7.541V7.517c0-4.158-3.391-7.541-7.558-7.541h-.158c-4.167 0-7.558 3.383-7.558 7.541v13.535c0 4.149 3.391 7.532 7.558 7.532zM26.783.945c3.624 0 6.576 2.946 6.576 6.563 0 .373-.308.68-.682.68a.685.685 0 01-.682-.68 5.21 5.21 0 00-5.213-5.202.685.685 0 01-.681-.68.673.673 0 01.681-.68z"}})])])
          )
        }
      }
    